<template>
  <v-container>
    <v-row justify="start" no-gutters class="my-2">
      <v-btn
        exact
        text
        :to="{
          name: 'CustomerIndex'
        }"
      >
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
    </v-row>
    <v-card v-if="customer">
      <v-card-text>
        <CustomerFields
          v-bind.sync="customer"
          :valid.sync="valid"
        ></CustomerFields>
      </v-card-text>
    </v-card>
    <v-container v-else class="my-3">
      <v-row align="center" justify="center" no-gutters class="my-3">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-row>
    </v-container>
    <v-row align="center" justify="end" no-gutters class="my-2">
      <v-btn
        class="mx-0"
        color="primary"
        :disabled="!customer || !valid"
        @click="saveData"
        :block="$vuetify.breakpoint.xsOnly"
        :large="$vuetify.breakpoint.smAndDown"
      >
        <v-icon left>save</v-icon>Enregistrer
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { CustomerFields } from "../components";
export default {
  name: "CustomerEditor",
  components: {
    CustomerFields
  },
  props: {
    id: {
      required: false,
      default: null
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  data() {
    return {
      valid: false,
      loading: true,
      customer: undefined
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        if (this.id !== null) {
          this.customer = await api.retrieveCustomer(this.id);
        } else {
          this.customer = {
            nom: "",
            courriel: "",
            telephone: "",
            adresse: ""
          };
        }
      } finally {
        this.loading = false;
      }
    },
    async saveData() {
      try {
        this.$store.dispatch("slo");
        if (this.id !== null) {
          await api.patchCustomer(this.id, this.customer);
        } else {
          await api.postCustomer(this.customer);
        }
        this.$router.push({ name: "CustomerIndex" });
      } finally {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
